import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-popup-header',
  templateUrl: './popup-header.component.html',
  styleUrls: ['./popup-header.component.less']
})
export class PopupHeaderComponent implements OnInit {
  @Input() caption: string =  '';
  @Input() showImage = true;
  @Input() color: 'yellow' | 'blue' = 'yellow';
  constructor() { }

  ngOnInit(): void {
  }

}
